// extracted by mini-css-extract-plugin
export default {"message_container":"PageNotFound_message_container__O0Kzq","text":"PageNotFound_text__vgY7i"};